import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const NearbyEventIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "NearbyEventIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M21.5 20.2082H2.5C2.22363 20.2082 2 19.9846 2 19.7082C2 19.4319 2.22363 19.2082 2.5 19.2082H21.5C21.7764 19.2082 22 19.4319 22 19.7082C22 19.9846 21.7764 20.2082 21.5 20.2082Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5 16.2161H2.5C2.22363 16.2161 2 15.9924 2 15.7161C2 15.4397 2.22363 15.2161 2.5 15.2161H21.5C21.7764 15.2161 22 15.4397 22 15.7161C22 15.9924 21.7764 16.2161 21.5 16.2161Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.10108 16.2161H2.5C2.22363 16.2161 2 15.9924 2 15.7161L2.00001 13.1848C2.00001 12.1926 2.80763 11.385 3.80079 11.385C4.79347 11.385 5.60108 12.1926 5.60108 13.1848V15.7161C5.60108 15.9924 5.37745 16.2161 5.10108 16.2161ZM3.00001 15.2161H4.60108V13.1848C4.60108 12.7434 4.24219 12.385 3.80079 12.385C3.35939 12.385 3.00001 12.7434 3.00001 13.1848V15.2161Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.3008 16.2161H10.6997C10.4233 16.2161 10.1997 15.9924 10.1997 15.7161V13.1848C10.1997 12.1926 11.0073 11.385 12 11.385C12.9932 11.385 13.8008 12.1926 13.8008 13.1848V15.7161C13.8008 15.9924 13.5772 16.2161 13.3008 16.2161ZM11.1997 15.2161H12.8008V13.1848C12.8008 12.7434 12.4414 12.385 12 12.385C11.5586 12.385 11.1997 12.7434 11.1997 13.1848V15.2161Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5 16.2161H18.8994C18.623 16.2161 18.3994 15.9924 18.3994 15.7161V13.1848C18.3994 12.1926 19.207 11.385 20.1997 11.385C21.1924 11.385 22 12.1926 22 13.1848L22 15.7161C22 15.9924 21.7764 16.2161 21.5 16.2161ZM19.3994 15.2161H21V13.1848C21 12.7434 20.6411 12.385 20.1997 12.385C19.7583 12.385 19.3994 12.7434 19.3994 13.1848L19.3994 15.2161Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.3374 20.2082H6.46338C6.18701 20.2082 5.96338 19.9846 5.96338 19.7082V15.7161C5.96338 15.4397 6.18701 15.2161 6.46338 15.2161H9.3374C9.61377 15.2161 9.8374 15.4397 9.8374 15.7161V19.7082C9.8374 19.9846 9.61377 20.2082 9.3374 20.2082ZM6.96338 19.2082H8.8374V16.2161H6.96338V19.2082Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4751 20.2082H14.6011C14.3247 20.2082 14.1011 19.9846 14.1011 19.7082V15.7161C14.1011 15.4397 14.3247 15.2161 14.6011 15.2161H17.4751C17.7515 15.2161 17.9751 15.4397 17.9751 15.7161V19.7082C17.9751 19.9846 17.7515 20.2082 17.4751 20.2082ZM15.1011 19.2082H16.9751V16.2161H15.1011V19.2082Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.1997 12.385C19.9233 12.385 19.6997 12.1614 19.6997 11.885V5.58618C19.0908 5.33813 17.5928 4.80005 16.0381 4.80005C14.4951 4.80005 13.0776 5.3313 12.5 5.57935V11.885C12.5 12.1614 12.2764 12.385 12 12.385C11.7236 12.385 11.5 12.1614 11.5 11.885V5.25806C11.5 5.06958 11.6055 4.89771 11.7734 4.81275C11.8545 4.77076 13.7886 3.80005 16.0381 3.80005C18.2808 3.80005 20.3291 4.76587 20.415 4.80689C20.5889 4.8899 20.6997 5.06568 20.6997 5.25806V11.885C20.6997 12.1614 20.4761 12.385 20.1997 12.385Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 11.9856C11.7236 11.9856 11.5 11.762 11.5 11.4856V5.58618C10.8916 5.33813 9.39307 4.80005 7.83838 4.80005C6.28906 4.80005 4.87647 5.33032 4.30078 5.57837V11.4856C4.30078 11.762 4.07715 11.9856 3.80078 11.9856C3.52441 11.9856 3.30078 11.762 3.30078 11.4856V5.25806C3.30078 5.06958 3.40625 4.89771 3.57422 4.81275C3.65527 4.77076 5.58887 3.80005 7.83838 3.80005C10.0815 3.80005 12.1294 4.76587 12.2153 4.80689C12.3892 4.8899 12.5 5.06568 12.5 5.25806V11.4856C12.5 11.762 12.2764 11.9856 12 11.9856Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.6997 13.8215H5.10108C4.82471 13.8215 4.60108 13.5979 4.60108 13.3215C4.60108 13.0452 4.82471 12.8215 5.10108 12.8215H10.6997C10.9761 12.8215 11.1997 13.0452 11.1997 13.3215C11.1997 13.5979 10.9761 13.8215 10.6997 13.8215Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.8994 13.8215H13.3008C13.0244 13.8215 12.8008 13.5979 12.8008 13.3215C12.8008 13.0452 13.0244 12.8215 13.3008 12.8215H18.8994C19.1758 12.8215 19.3994 13.0452 19.3994 13.3215C19.3994 13.5979 19.1758 13.8215 18.8994 13.8215Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default NearbyEventIcon;
